import {withTracker} from 'react-meteor-data-with-tracker';
import {ISlideStream, SlideStream} from 'shared/collections/SlideStream';
import {publishNames} from 'shared/constants/publishNames';
import {withContentRect} from 'react-measure';
import SlideshowPageWrapper from './SlideshowPageWrapper';

export default withTracker(() => {
	const isStream = window.location.pathname.startsWith('/stream');
	const slideshowNumId = isStream
		? window.location.pathname.substring(1).split('/')[1]
		: window.location.pathname.substring(1);

	let isReady = true;
	let currentStream: ISlideStream | undefined;

	if (isStream) {
		isReady = Meteor.subscribe(publishNames.slideStream.streamById, slideshowNumId).ready();
		currentStream = SlideStream.findOne({code: slideshowNumId});
	}

	return {
		isStream,
		slideshowNumId,
		currentStream,
		loading: !isReady,
	};
})(withContentRect('bounds')(SlideshowPageWrapper));
